/**
 * Bundles – Quick-add modal logic
 * Mirrors the Products Scroll modal behavior:
 * toggle +/−, variant matching, quantity, AJAX add-to-cart.
 */

(function () {
  'use strict';

  function initBundlesModals() {
    var bundleCells = document.querySelectorAll('.bd-cell--bundle');

    bundleCells.forEach(function (cell) {
      var toggleBtn = cell.querySelector('[data-bd-toggle]');
      var modal = cell.querySelector('[data-bd-modal]');
      if (!toggleBtn || !modal) return;

      var isDesktop = window.innerWidth > 991;

      if (isDesktop) {
        /* Desktop: click anywhere on the card opens/closes modal */
        cell.addEventListener('click', function (e) {
          /* Only skip toggle for interactive form controls inside the modal */
          var interactive = e.target.closest('select, input, [data-bd-qty-minus], [data-bd-qty-plus], [data-bd-atc], a.ps-modal__view-details, .ps-modal__variant-select-wrap');
          if (interactive && modal.contains(interactive)) return;
          e.preventDefault();
          cell.classList.toggle('is-modal-open');
        });
      } else {
        /* Mobile: click on + button (existing) */
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          cell.classList.toggle('is-modal-open');
        });
        /* Mobile: click on tags or title text also opens/closes modal */
        var contentTags = cell.querySelector('.products-scroll__content .products-scroll__tags');
        var contentTitle = cell.querySelector('.products-scroll__content .products-scroll__title');
        var modalTags = cell.querySelector('.products-scroll__modal .products-scroll__tags');
        var modalTitle = cell.querySelector('.products-scroll__modal-title');
        [contentTags, contentTitle, modalTags, modalTitle].forEach(function (el) {
          if (!el) return;
          el.style.cursor = 'pointer';
          el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            cell.classList.toggle('is-modal-open');
          });
        });
      }

      /* --- Variant matching --- */
      var variantsJson = modal.querySelector('[data-bd-variants]');
      var variantIdInput = modal.querySelector('[data-bd-variant-id]');
      var optionSelects = modal.querySelectorAll('[data-bd-option]');
      var variants = [];

      if (variantsJson) {
        try { variants = JSON.parse(variantsJson.textContent); } catch (err) { /* noop */ }
      }

      function matchVariant() {
        var selectedOptions = [];
        optionSelects.forEach(function (sel) {
          selectedOptions.push(sel.value);
        });

        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            variantIdInput.value = v.id;
            return;
          }
        }
      }

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', matchVariant);
      });

      /* --- Quantity controls --- */
      var qtyInput = modal.querySelector('[data-bd-qty]');
      var formQty = modal.querySelector('[data-bd-form-qty]');
      var minusBtn = modal.querySelector('[data-bd-qty-minus]');
      var plusBtn = modal.querySelector('[data-bd-qty-plus]');

      if (qtyInput && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) {
            qtyInput.value = val - 1;
            if (formQty) formQty.value = val - 1;
          }
        });

        plusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val < 99) {
            qtyInput.value = val + 1;
            if (formQty) formQty.value = val + 1;
          }
        });

        qtyInput.addEventListener('change', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          val = Math.max(1, Math.min(99, val));
          qtyInput.value = val;
          if (formQty) formQty.value = val;
        });
      }

      /* --- AJAX Add to cart --- */
      var cartForm = modal.querySelector('[data-bd-cart-form]');
      var atcBtn = modal.querySelector('[data-bd-atc]');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cartForm && atcBtn) {
        cartForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var originalText = atcBtn.textContent;
          atcBtn.textContent = 'Adding...';
          atcBtn.disabled = true;

          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var formData = new FormData();
          formData.append('id', variantIdInput.value);
          formData.append('quantity', formQty ? formQty.value : '1');

          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cart.getSectionsToRender().map(function (section) {
                return section.id;
              })
            );
            formData.append('sections_url', window.location.pathname);
          }

          config.body = formData;

          fetch(routes.cart_add_url, config)
            .then(function (res) {
              return res.json();
            })
            .then(function (response) {
              if (response.status) {
                throw new Error(response.description || response.message || 'Add to cart failed');
              }

              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'bundles',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }

              if (cart.tagName === 'CART-DRAWER') {
                cart.renderContents(response, {
                  source: 'bundles',
                  forceOpenOnHomepage: true,
                });
              } else {
                cart.renderContents(response);
              }

              atcBtn.textContent = 'Added ✓';
              setTimeout(function () {
                atcBtn.textContent = originalText;
                atcBtn.disabled = false;
                cell.classList.remove('is-modal-open');
              }, 1500);
            })
            .catch(function () {
              atcBtn.textContent = 'Error - retry';
              atcBtn.disabled = false;
              setTimeout(function () {
                atcBtn.textContent = originalText;
              }, 2000);
            });
        });
      }
    });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlesModals);
  } else {
    initBundlesModals();
  }
})();
